export default __webpack_public_path__ + "static/approach-0-6a6c87f6d5ced6fe960d7ec6f3ec4970.svg";